<template>
  <div>
    <v-row dense v-if="settings.guest_day.new_time_changes" class="mt-2">
      <v-col cols="12">
        <div class="guest-grid guest-grid-header">
          <div class="guest-group-header guest-group-empty"></div>
          <div class="guest-group-header guest-group-time">
            {{ $t("time_for_deliver") }}
          </div>
        </div>

        <div class="guest-grid guest-grid-subheader">
          <div class="guest-header-cell">{{ $t("day") }}</div>
          <div class="guest-header-cell">{{ $t("from") }}</div>
          <div class="guest-header-cell">{{ $t("to") }}</div>
          <div class="guest-header-cell">{{ $t("first_day_of_order") }}</div>
          <div class="guest-header-cell">{{ $t("limit") }}</div>
          <div class="guest-header-cell">{{ $t("day_after_limit") }}</div>
        </div>

        <v-sheet v-for="day in weekDays" :key="day.key" class="guest-strip" outlined>
          <div class="guest-grid guest-grid-row">
            <div class="guest-day-col">
              <div class="guest-day-badge">
                {{ day.label }}
              </div>
            </div>

            <div>
              <time-picker
                :value="getTimeString(day.key, 'start')"
                label=""
                :minute-interval="15"
                :hide-details="true"
                @input="setTimeString(day.key, 'start', $event)"
              />
            </div>

            <div>
              <time-picker
                :value="getTimeString(day.key, 'end')"
                label=""
                :minute-interval="15"
                :hide-details="true"
                @input="setTimeString(day.key, 'end', $event)"
              />
            </div>

            <div>
              <text-field
                label=""
                type="number"
                hide-details
                v-model="settings.guest_day[day.key].day_before_limit"
              />
            </div>

            <div>
              <time-picker
                :value="getTimeString(day.key, 'limit')"
                label=""
                :minute-interval="15"
                :hide-details="true"
                @input="setTimeString(day.key, 'limit', $event)"
              />
            </div>

            <div>
              <text-field
                label=""
                type="number"
                hide-details
                v-model="settings.guest_day[day.key].day_after_limit"
              />
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import hasTimeValidation from "@/mixins/hasTimeValidation";

export default {
  name: "GuestDailyTimeChangesSection",
  mixins: [hasTimeValidation],
  props: {
    settings: {
      type: Object,
      required: true,
    },
    weekDays: {
      type: Array,
      required: true,
    },
    deliveryFrom: {
      type: Array,
      required: true,
    },
    deliveryTo: {
      type: Array,
      required: true,
    },
    deliveryFromHour: {
      type: Array,
      required: true,
    },
    deliveryToMin: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getTimeString(dayKey, type) {
      if (!this.settings?.guest_day?.[dayKey]) return "";

      if (type === "start") {
        const hours = this.settings.guest_day[dayKey].working_hours.delivery_from;
        const minutes = this.settings.guest_day[dayKey].working_hours.delivery_to;
        if (!this.isValidTimePair(hours, minutes)) return "";
        return `${this.padTime(hours)}:${this.padTime(minutes)}`;
      }

      if (type === "end") {
        const hours = this.settings.guest_day[dayKey].working_hours.delivery_from1;
        const minutes = this.settings.guest_day[dayKey].working_hours.delivery_to1;
        if (!this.isValidTimePair(hours, minutes)) return "";
        return `${this.padTime(hours)}:${this.padTime(minutes)}`;
      }

      if (type === "limit") {
        const hours = this.settings.guest_day[dayKey].time.time_hour;
        const minutes = this.settings.guest_day[dayKey].time.time_minut;
        if (!this.isValidTimePair(hours, minutes)) return "";
        return `${this.padTime(hours)}:${this.padTime(minutes)}`;
      }

      return "";
    },
    setTimeString(dayKey, type, value) {
      if (!this.settings?.guest_day?.[dayKey]) return;
      if (!value) {
        if (type === "start") {
          this.settings.guest_day[dayKey].working_hours.delivery_from = "";
          this.settings.guest_day[dayKey].working_hours.delivery_to = "";
        }
        if (type === "end") {
          this.settings.guest_day[dayKey].working_hours.delivery_from1 = "";
          this.settings.guest_day[dayKey].working_hours.delivery_to1 = "";
        }
        if (type === "limit") {
          this.settings.guest_day[dayKey].time.time_hour = "";
          this.settings.guest_day[dayKey].time.time_minut = "";
        }
        return;
      }

      const parsed = this.parseTimeValue(value);
      if (!parsed) {
        if (type === "start") {
          this.settings.guest_day[dayKey].working_hours.delivery_from = "";
          this.settings.guest_day[dayKey].working_hours.delivery_to = "";
        }
        if (type === "end") {
          this.settings.guest_day[dayKey].working_hours.delivery_from1 = "";
          this.settings.guest_day[dayKey].working_hours.delivery_to1 = "";
        }
        if (type === "limit") {
          this.settings.guest_day[dayKey].time.time_hour = "";
          this.settings.guest_day[dayKey].time.time_minut = "";
        }
        return;
      }

      const normalizedHours = parsed.hours;
      const normalizedMinutes = parsed.minutes;

      if (type === "start") {
        this.settings.guest_day[dayKey].working_hours.delivery_from = normalizedHours;
        this.settings.guest_day[dayKey].working_hours.delivery_to = normalizedMinutes;
      }
      if (type === "end") {
        this.settings.guest_day[dayKey].working_hours.delivery_from1 = normalizedHours;
        this.settings.guest_day[dayKey].working_hours.delivery_to1 = normalizedMinutes;
      }
      if (type === "limit") {
        this.settings.guest_day[dayKey].time.time_hour = normalizedHours;
        this.settings.guest_day[dayKey].time.time_minut = normalizedMinutes;
      }
    },
  },
};
</script>

<style scoped>
.guest-strip {
  padding: 10px 12px;
  border-radius: 10px;
  margin-bottom: 10px;
  background: #fff;
}

.guest-grid {
  display: grid;
  grid-template-columns: 110px 1fr 1fr 1fr 1fr 1fr;
  column-gap: 12px;
  align-items: center;
}

.guest-grid-header {
  padding: 0 8px 6px;
}

.guest-grid-subheader {
  padding: 0 8px 6px;
}

.guest-group-header {
  font-size: 0.75rem;
  font-weight: 700;
  color: #000;
  letter-spacing: 0.02em;
  text-align: center;
}

.guest-group-empty {
  grid-column: 1 / 2;
}

.guest-group-time {
  grid-column: 2 / 4;
}

.guest-group-before {
  grid-column: 4 / 5;
}

.guest-group-limit {
  grid-column: 5 / 6;
}

.guest-group-after {
  grid-column: 6 / 7;
}

.guest-grid-row {
  padding: 4px 0;
}

.guest-header-cell {
  font-size: 0.75rem;
  font-weight: 600;
  color: #000;
  letter-spacing: 0.02em;
}

.guest-day-col {
  max-width: 110px;
}

.guest-day-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 8px;
  background: #ffece6;
  font-weight: 600;
  font-size: 0.85rem;
  white-space: nowrap;
}
</style>
